import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { supplierAccountQueryKeys } from '@/features/supplier/account/queryKeys'
import { subscribeSupplierSessionChanges } from '@/stores/auth-session.broadcast'
import { useAuthStore } from '@/stores/auth.store'

export function SupplierSessionSynchronizer() {
  const queryClient = useQueryClient()

  useEffect(() => {
    const unsubscribeSessionChanges = subscribeSupplierSessionChanges(() => window.location.reload())
    const unsubscribeAuthStore = useAuthStore.subscribe((state, previousState) => {
      if (state.token === previousState.token) return
      queryClient.removeQueries({ queryKey: supplierAccountQueryKeys.profile })
    })
    return () => {
      unsubscribeSessionChanges()
      unsubscribeAuthStore()
    }
  }, [queryClient])
  return null
}
